import { AppPage } from "../components/AppPage";

export const LoadingPage = (): JSX.Element => <AppPage>{null}</AppPage>;
